import React, { Component } from 'react';
import { Tooltip } from '@material-ui/core';
import { Mic, Radio, PlaylistPlay } from '@material-ui/icons';
import { shape, func, string, number, arrayOf, oneOf, element, bool } from 'prop-types';
import cx from 'classnames';
import { TYPE_LIVE_READ, TYPE_PRE_RECORDED, TYPE_WATCHLIST } from '../constants';
import styles from './styles.scss';

export default class CreativeTableRow extends Component {
  static propTypes = {
    data: shape({
      creativeName: string,
      adType: string,
      adTypeId: oneOf([TYPE_LIVE_READ.id, TYPE_PRE_RECORDED.id, TYPE_WATCHLIST.id]),
      duration: string,
      stations: arrayOf(string),
      ads: number,
      adVisit: number,
      adUser: number,
      visitOfAds: number,
      avgAdCost: number
    }),
    onCellClick: func,
    preRecordedIcon: element,
    liveReadsIcon: element,
    watchlistIcon: element,
    isAvgCostDisabled: bool,
    liveReadsTooltipText: string,
    preRecordedTooltipText: string,
    watchListTooltipText: string,
    isCustomReport: bool,
    isNewAdUsersSelected: bool,
  }

  static defaultProps = {
    data: {},
    preRecordedIcon: <Radio/>,
    liveReadsIcon: <Mic/>,
    watchlistIcon: <PlaylistPlay/>,
    liveReadsTooltipText: 'Live Read',
    preRecordedTooltipText: 'Pre-recorded',
    watchListTooltipText: 'Watchlist',
  }

  getAdTypeElements() {
    const {
      data,
      liveReadsIcon,
      liveReadsTooltipText,
      preRecordedIcon,
      preRecordedTooltipText,
      watchlistIcon,
      watchListTooltipText
    } = this.props;
    const { adTypeId } = data;
    let adTypeIcon;
    let iconTooltipText;

    switch(adTypeId) {
      case TYPE_LIVE_READ.id:
        adTypeIcon = liveReadsIcon;
        iconTooltipText = liveReadsTooltipText;
        break;
      case TYPE_WATCHLIST.id:
        adTypeIcon = watchlistIcon;
        iconTooltipText = watchListTooltipText;
        break;
      default:
        adTypeIcon = preRecordedIcon;
        iconTooltipText = preRecordedTooltipText;
    }

    return { adTypeIcon, iconTooltipText };
  }

  render() {
    const { 
      data, 
      onCellClick,
      isAvgCostDisabled,
      isCustomReport,
      isNewAdUsersSelected,
    } = this.props;
    const { creativeName, duration, ads, adVisit, avgAdCost, newAdUsers, newAdUsersPerAds } = data; //TODO: adUser
    const formattedAdVisit = parseFloat(adVisit.toFixed(1));
    const formattedNewAdUsers = parseFloat(newAdUsers.toFixed(1));
    const { adTypeIcon, iconTooltipText } = this.getAdTypeElements();
    const localeAvgAdCost = avgAdCost == null ? 'N/A' : `$${avgAdCost.toFixed(2).toLocaleString()}`;
    const tableCellClasses = isCustomReport ? cx(styles.tableCell, styles.customTableCell) : styles.tableCell;
    const formattedVisitOfAds = ads ? parseFloat((adVisit/ads).toFixed(2)) : 0;
    const formattedNewAdUsersPerAds = ads ? parseFloat((newAdUsers/ads).toFixed(2)) : 0;
    const metricPerAdTableCellClasses = cx(
      styles.tableCell,
      styles.metricPerAdCell,
      {
        [styles.customTableCell]: isCustomReport
      }
    );

    return (
      <div className={styles.tableRow}>
        <div className={tableCellClasses}>
          <Tooltip title={creativeName}>
            <span data-test="creativeTableName" className={styles.name}>{creativeName}</span>
          </Tooltip>
        </div>
        <div className={tableCellClasses}>
          <Tooltip data-test="creativeTableType" title={iconTooltipText}>
            {adTypeIcon}
          </Tooltip>
        </div>
        <div data-test="creativeTableDuration" className={tableCellClasses}>{duration}</div>
        {isNewAdUsersSelected 
          ? <div data-test="creativeTableNewAdUsers" className={tableCellClasses} onClick={onCellClick({data, key: 'newAdUsers'})}>{formattedNewAdUsers.toLocaleString()}</div>
          : <div data-test="creativeTableAdVisits" className={tableCellClasses} onClick={onCellClick({data, key: 'adVisit'})}>{formattedAdVisit.toLocaleString()}</div>
        }
        {/* <div className={styles.tableCell} onClick={onCellClick({data, key: 'adUser'})}>{adUser.toLocaleString()}</div> */}
        <div data-test="creativeTableAds" className={tableCellClasses} onClick={onCellClick({data, key: 'ads'})}>{ads.toLocaleString()}</div>
        {isNewAdUsersSelected 
          ? <div
            data-test="creativeTableNewAdUsersPerAds"
            className={metricPerAdTableCellClasses}
            onClick={onCellClick({data, key: 'newAdUsersPerAds'})}
          >
            {formattedNewAdUsersPerAds.toLocaleString()}
          </div>
          : <div
              data-test="creativeTableAdvisitsAds"
              className={metricPerAdTableCellClasses}
              onClick={onCellClick({data, key: 'visitOfAds'})}
            >
              {formattedVisitOfAds.toLocaleString()}
            </div>
        }
        { 
          !isAvgCostDisabled &&
          <div data-test="creativeTableAvgAdCost" className={tableCellClasses} onClick={onCellClick({data, key: 'avgAdCost'})}>{localeAvgAdCost}</div>
        }
      </div>
    )
  }
}
